export default {
    namespaced: true,
    state: {
        expInSecCounter: undefined
    },
    mutations: {
        setExpInSec(state, expInSec) {
            state.expInSecCounter = expInSec
        },
        decrementCounter(state) {
            state.expInSecCounter--
        },
        clearCounter(state) {
            state.expInSecCounter = undefined
        }
    },
    actions: {},
    getters: {
        getExpInSecCounter: (state) => state.expInSecCounter
    },
}